export default function capitalizeFirstLetter(string) {
  string = string ? string.replace('&', 'And') : '';
  string = string ? string.replace('/', ' ') : '';
  string = string ? string.replace("'", '') : '';
  string = string ? string.replace('%', '') : '';

  const words = string ? string.split(' ') : [];

  return words
    .map((word) => {
      return word[0].toUpperCase() + word.substring(1);
    })
    .join(' ');
}
